import {StatisticsUpdateEvent} from "../../../nodeserver/structs/websocket";
import {ICommentable, Role} from "../../../nodeserver/structs/database";
import {ImportExportFavorites} from "./profile/import-favorites.js";
import {DialogShare} from "./helpers/share.js";
import {
    ErrorCode,
    handleFetchError,
    numberToBgImage,
    showDialogRecaptcha,
    YummyServerError,
    openDropList,
    closeDropList, formatWord, showNotice, HtmlDialog, showAskDialog
} from "./helpers/functions.js";
import {APIGateway, ServerApi} from "./api.js";
import {Websocket} from "./websocket.js";
import {DataStore} from "./helpers/datastore.js";
import {PreviewAnimeDialog} from "./dialogs/preview-anime.js";
import JSX from "./helpers/react.js";
import {OtherListsStatistics} from "./models/OtherListsStatistics.js";
import {favoriteTypes, posterSizes} from "./config.js";
import RefObject = JSX.RefObject;

declare global {
    function profileListDate(): void;

    interface JQuery {
        bgColor(): string;

        fgColor(): string;

        isInViewport(): boolean;

        slimSelect(f?: (v: string) => any): JQuery;

        slimSet(value: any): JQuery

        slimDestroy(): JQuery
    }

    // const favoriteTypes: ReadonlyArray<IListStatus>;
    interface Storage {
        muted?: 'true' | 'false';
        lastReviewText?: string;
        designSwitch?: string;
        viewPageTop?: 'list' | 'grid';
        ageConfirmAnimes?: string;
        filterSwitch?: string;
        localStorage?: string;
        defaultAnimesSort?: string;
        autoSkipOpening?: 'true' | 'false';
        autoSkipNextEp?: 'true' | 'false';
    }

    interface JQueryStatic {
        cookie(name: string, value?: string, options?: { path?: string; expires?: Date | number }): string;
    }

    function closeModal(what: JQuery): void;

    const mobileOperatingSystem: 'iOS' | 'Android' | 'IE' | 'Edge' | 'Opera' | 'unknown';
    // function showAskDialog(question: string, description: string, buttonOk?: string, buttonCancel?: string) : Promise<boolean>;
    // const favoritesTitles: {[k: number]: string};
    const themes: string[];
    const user_id: number | undefined;
    const user_nickname: string | undefined;
    const page_type: ICommentable | '' | 'moderator';
    const page_id: number | undefined;
    const supportedImageFormats: { webp: boolean; avif: boolean; };
    const ratingList: ReadonlyArray<string>;
    const userRoles: ReadonlyArray<Role>;
    const is_ukraine: boolean;

    // function slimCustom(this: HTMLElement, addableFn?: (v: string)=>any): SlimSelectParams;
    function ym(id: 92092678, key: 'reachGoal', action: string): any;
    function ym(id: 92092678, key: 'getClientID', action: (clientId: string) => any): any;

    class SlimSelect {
        constructor(params: SlimSelectParams);
    }

    interface SlimSelectParams {
        showSearch?: boolean,
        searchFilter?: (o: { text: string }, s: string) => boolean,
        select: HTMLSelectElement,
        searchPlaceholder?: string,
        searchText?: string,
        placeholder?: string,
        showContent?: 'down' | 'up',
        allowDeselectOption?: boolean,
        closeOnSelect?: boolean,
        beforeOpen?: () => any,
        beforeClose?: () => any,
        addable?: (val: any) => any,
        searchingText?: string,
        ajax?: (search: any, callback: any) => any;
    }

    interface HTMLSelectElement {
        slim: {
            selected(): boolean;
            destroy(): boolean;
            set(v: number): void;
        }
    }

    interface Date {
        addHours(hours: number): Date;
    }

    interface String {
        toInt(): number;
    }

    interface HTMLImageElement {
        toDataUrl(format?: 'image/png' | 'image/jpeg'): Promise<string>;
    }
}
{
    Date.prototype.addHours = function (h) {
        this.setTime(this.getTime() + (h * 60 * 60 * 1000));
        return this;
    };

    $.fn.slimSet = function (this: JQuery<HTMLSelectElement>, v: any) {
        this.each(function () {
            if (this.slim?.selected() != v && this.innerHTML.indexOf('value="' + v + '"') > -1) {
                this.slim.set(v);
            }
        })
        return this;
    };

    $.fn.slimDestroy = function (this: JQuery<HTMLSelectElement>) {
        this.each(function (): void {
            this.slim.destroy();
        })
        return this;
    };
    $.fn.isInViewport = function isInViewport(): boolean {
        const elementTop = $(this).offset()!.top,
            elementBottom = elementTop + $(this).outerHeight()!,
            viewportTop = $(window).scrollTop()!,
            viewportBottom = viewportTop + $(window).height()!;

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
}
$('html')
    .on('mouseover', '.update-img', async function () {
        const $this = $(this),
            left = $this.offset()!.left,
            width = $this.width()!,
            top = $this.offset()!.top,
            height = $this.height();

        if ($this.parent().prop('tagName') === 'BODY') return;
        let overed = true;
        $this.one('mouseout', () => {
            overed = false;
        })
        await new Promise(r => setTimeout(r, 150));
        if (!overed) return;
        const cloned = $(this).clone(false)
            .prop('src', $(this).data('medium'))
            .addClass('show-big-img')
            .css('height', height + 'px')
            .css('width', width + 'px')
            .css('top', top + 'px')
            .css('left', left + 'px')
            .appendTo('body');
        // cloned[0].style.setProperty('--data-left', left+'px');
        if (left < width * 3.5 / 2) cloned.addClass('move-left');
        cloned.on('mouseout', () =>
            setTimeout(() => {
                if (cloned.width() === $(this).width()) cloned.remove();
            }, 400)
        )

    })
    .on('click', '#to-top', function () {
        $(this).hide();
        setTimeout(() => $(this).css('display', 'block'), 600)
        $('body').addClass('block-scroll');
        $('body,html').animate({
            scrollTop: 0
        }, 300, function () {
            $('body').removeClass('block-scroll');
        });
    })
    .on('touchstart mousedown', '.dialog-bg', function (e) {
        const el = $(e.target);
        const suc = el.hasClass('dialog-bg') || el.hasClass('cancel-button');
        $(this).data('success', suc);
    })
    .on('click', '.dialog-bg', function (e) {
        const el = $(e.target);
        const suc = $(this).data('success');
        if (suc && (el.hasClass('dialog-bg') || el.hasClass('cancel-button')))
            $(this).data('close-event')();
        // else e.preventDefault();
    })
    // .on('change', 'select[name=sort]', function(){
    //     const order=$(this).find('option:checked').data('sort-order'),
    //         sortBtn = $('.sort-order-button');
    //     if({'0': 'DESC', '1': 'ASC'}[sortBtn.find('input[name=sort_order]').val()! as '0'|'1'] != order )
    //         sortBtn.trigger('click');
    // })

    // Profile
    .on('click', '.close-select-profile-bg', function (this: HTMLElement) {
        $(this).fadeOut(150).promise().done(() => $(this).remove());
        const next = $(this.nextElementSibling!).css('transition', '.3s')
            .css('min-height', '0px')
            .css('height', '0px')
            .css('opacity', '0')
        setTimeout(() => next.remove(), 300)
        next.find('.shadow-text').remove()
        $.cookie('hide_select_bg', '1', {expires: new Date(Date.now() + 3600 * 1000 * 24 * 30)}); // for 30 days
    })
    //avatar
    .on('input', 'input[name=select-avatar]', function () {

        function readFile(input: HTMLInputElement, success: (c: string) => any) {
            if (input.files && input.files[0]) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    success(e!.target!.result as string)
                };
                reader.readAsDataURL(input.files[0]);
            } else {
                showNotice("Перезагрузите страницу и попробуйте снова", 'Ошибка', 'error');
            }
        }

        readFile(this, img => showChangeImageDialog(img));
    })
    .on('click', '.avatar', function (e) {
        if (e.target.name === 'select-avatar' || (page_id != user_id && !userRoles.includes('root') && !userRoles.includes('admin'))) return;
        const $dialog = (
            <HtmlDialog className="edit-anime">
                <div className="top-data">
                    <h1>Установка аватарки</h1>
                    <div className="content" style="display:block;">
                        <p>Перед установкой, пожалуйста, ознакомьтесь с <b>правилами</b> для аватарок:
                            <ol>
                                <li> аватарка пользователя — статичное изображение с расширением файла .png или
                                    .jpg(.jpeg)
                                </li>
                                <li> на изображении не должна присутствовать нецензурная лексика или нецензурные
                                    жесты.
                                </li>
                                <li> изображение не должно содержать контент 18+ (эротику, запрещенные символы и т.п.)
                                </li>
                                <li> изображение не должно содержать насилие или пропаганду (наркотиков, религии,
                                    фашизма и т.д.)
                                </li>
                            </ol>
                        </p>
                        <p>При нарушении данных правил, Ваш аккаунт будет <b>ЗАБЛОКИРОВАН</b>!</p>
                    </div>
                </div>
                <div className="bottom-buttons">
                    <button className="main-button bordered generator transparent close-dialog close-dialog"
                            onClick={showWaifuGeneratorWindow}>
                        Вайфу генератор
                    </button>
                    <button className="main-button bordered remove" onClick={removeAvatar}>
                        Удалить аватарку
                    </button>
                    <button className="main-button bordered add close-dialog"
                            onClick={() => $("input[name=select-avatar]").trigger('click')}>
                        Согласен, загрузить!
                    </button>
                </div>
            </HtmlDialog>
        )
        // .appendTo('body');
        document.body.appendChild($dialog);
    })
    //Background
    .on('click', '.profile-bg-img', function () {
        if (user_id != page_id) return;
         $('body').css('overflow', 'hidden');
        const profileSrcs = Array.from({length: 42}, (_, i) => numberToBgImage(i + 1));
        const profileBgImg = $('.profile-bg-img')[0];
        const $dialog = $(<HtmlDialog>
                <div className="top-data">
                    <div className="fa fa-times-circle top-icon-close-dialog cancel-button" style="margin: 5px"></div>
                    <h1>Выбор заднего фона</h1>
                    <div className="text-items">
                        <input type="text" name="text1" maxlength="30" placeholder="Левый текст"/>
                        <input type="text" name="text2" maxlength="30" placeholder="Правый текст"/>
                        <div className="color-select">
                            <div className="selector"></div>
                        </div>
                    </div>
                </div>
                <div className="vertical-scroll-container">
                    <div className="content" style="display: block">
                        <div className="bg-item" data-id="0" style={{
                            textAlign: 'center', fontSize: '23px',
                            background: 'var(--background-third)',
                            borderRadius: '3px',
                            padding: '63px',
                            margin: '2px 6px'
                        }}>
                            <span>Без фона</span>
                        </div>
                        {
                            ...profileSrcs.map(src =>
                                <div className="bg-item" data-id={src.split('.')[0]}>
                                    <img alt="" src={`//img.yani.tv/img/bg/users/${src}`}/>
                                </div>
                            )
                        }
                    </div>
                </div>
            </HtmlDialog>
        )
            .on('click', '.bg-item', async function () {
                $dialog.find('.bg-item.selected').removeClass('selected');
                $(this).addClass('selected');
                const id = $(this).data('id');
                try {
                    await ServerApi.profile.setSettings({profile_bg_img: id});
                    const $el = $('.profile-bg-img');
                    $el[0].style.setProperty('--image', `url("//img.yani.tv/img/bg/users/${numberToBgImage(id)}")`)
                    $el
                        .attr('data-id', id)
                        [id == 0 ? 'addClass' : 'removeClass']('select-bg-img')
                        [id == 0 ? 'removeClass' : 'addClass']('current')
                        .find('span')
                        .text(id == 0 ? 'Выбрать задний фон' : 'Изменить задний фон')
                } catch (e) {
                    handleFetchError(e);
                }
            })
            .appendTo('body')
            .on('mousemove touchmove', function (e) {
                if (!down) return;
                e.preventDefault();
                const $this = $dialog.find('.color-select');
                // @ts-ignore
                let parentPos: number = (e.pageX ?? e.originalEvent.touches[0].pageX) - $this.offset().left!
                let left = Math.min(Math.max(parentPos / $this.width()!, 0), 1);
                color = left * 360;
                colorChange();
                $this.children('.selector').css('left', left.toLocaleString('en', {
                    style: 'percent',
                    minimumFractionDigits: 2
                }));
            })
            .on('mousedown touchstart', (e) => {
                // @ts-ignore
                const target: HTMLElement = e.type === 'touchstart' ? document.elementFromPoint(e.originalEvent.changedTouches[0].clientX, e.originalEvent.changedTouches[0].clientY) : e.target;
                if ($(target).is('.color-select') || $(target).parents('.color-select')[0])
                    down = true
            })
            .on('mouseup touchend', () => {
                if (down) {
                    colorChange(true);
                }
                down = false;
            })
            .on('input paste change', 'input[name=text1]', function () {
                textLeft = $(this).val()! as string;
                updateTextLeft();
            })
            .on('input paste change', 'input[name=text2]', function () {
                textRight = $(this).val()! as string;
                updateTextRight();
            })
        let down = false,
            color: number = +profileBgImg.style.getPropertyValue('--shadow-color'),
            textLeft = $('.vertical-text:not(.backwards)').eq(0).text(),
            textRight = [...$('.vertical-text.backwards').eq(0).text()].reverse().join('');
        $dialog.find('.selector').css('left', color / 3.6 + "%");
        {
            const selectedEl = $dialog.find(`.bg-item[data-id=${$(profileBgImg).attr('data-id') || 0}]`)
                .addClass('selected')
                [0].offsetTop;
            $dialog.find('.vertical-scroll-container')[0].scrollTop = selectedEl - 100;
        }
        $dialog.find('input[name=text1]').val(textLeft);
        $dialog.find('input[name=text2]').val(textRight);

        function colorChange(save: boolean = false) {
            profileBgImg.style.setProperty('--shadow-color', Math.floor(color) + '')
            if (save) ServerApi.profile.setSettings({bg_color: Math.floor(color)}).catch(handleFetchError);
        }

        function getDataAsString(str: string): string {
            const chars = [...str].map(ch => escapeHtml(ch));
            return chars.join('<br>');
        }

        function updateTextLeft() {
            $(".vertical-text:not(.backwards)")
                .html(getDataAsString(textLeft))
                .each((_, el) => el.style.setProperty('--anim-dur', textLeft.length * .5 + "s"));
            const tr1 = textLeft;
            setTimeout(() => {
                if (tr1 === textLeft)
                    ServerApi.profile.setSettings({text: {left: textLeft}}).catch(handleFetchError);
            }, 500);
        }

        function updateTextRight() {
            let textH = [...textRight].reverse().join('');
            $(".vertical-text.backwards")
                .html(getDataAsString(textH))
                .each((_, el) => el.style.setProperty('--anim-dur', textRight.length * .5 + "s"));
            const tr1 = textRight;
            setTimeout(() => {
                if (tr1 === textRight)
                    ServerApi.profile.setSettings({text: {right: textRight}}).catch(handleFetchError);
            }, 500);
        }
    })
    //Import favorites
    .on('click', '.import-favorites-button', ImportExportFavorites.showWindow)
    //Logout
    .on('click', '.logout-btn', async function () {
        try {
            await ServerApi.profile.logout();
            showNotice("Вы вышли из аккаунта...", '\\-_-/', 'normal')
            window.location.reload();
        } catch (e) {
            handleFetchError(e);
        }
    })
    //Toggle login form
    .on('click', '.login', function () {
        if ($(this).parent().prop('tagName').toLowerCase() != 'form')
            $('.login-form').toggleClass('open')
    })

    //Notifications
    .on('click', '.clear-notifications', async function () {
        const verify = await showAskDialog(
            <>Удалить <b>все</b> уведомления?</>,
            <>Обратите внимание, что <b>все</b> уведомления будут очищены <b>навсегда</b>.<br/>Вы уверены в этом?</>
        );
        if (!verify) return;
        try {
            await ServerApi.profile.notifications.removeAll();
            // const response = await fetchServer<{status: boolean}>("/actions/profile/notifications.php?verify=true", 'DELETE');
            showNotice("Все уведомления удалены", 'Успех ツ')
            $('.notification').remove();
            $('.notifications-content').html('<div class="empty">Тут пока пусто \\__(ツ)__/</div>');
            updateNotificationCounts();
        } catch (e) {
            handleFetchError(e);
        }
    })
    .on('click', '.notification', async function (e) {
        if ($(e.target).hasClass('close')) {
            $(e.target).addClass('blocked');
            $(this).fadeOut(400);
            try {
                await ServerApi.profile.notifications.removeById($(this).data('id'));
                // const response = await fetchServer<{status: boolean}>("/actions/profile/notifications.php?"+new URLSearchParams({
                //     id: $(this).data('id')
                // }), 'DELETE');
                await new Promise(resolve => setTimeout(resolve, 300));
                $(this).remove();
                if (!$('.notification')[0])
                    $('.notifications-content').html('<div class="empty">Тут пока пусто \\__(ツ)__/</div>');

                updateNotificationCounts();
            } catch (e) {
                handleFetchError(e);
                $(this).fadeIn(1);
            } finally {
                $(e.target).removeClass('blocked');
            }
        } else {
            const $this = $(this), url = $this.data('uri');
            if (url) location.href = url;
        }
    })
    .on('click', '.notification-item:not(.selected)', function () {
        $('.notification-item.selected').removeClass('selected');
        $(this).addClass('selected');
        const type = $(this).data('type');
        if (type === 'all') {
            if ($('.notification').fadeIn(100)[0])
                $('.notifications-content .nothing-found').remove();
            else if (!$('.notifications-content .nothing-found')[0])
                $('<div class="empty nothing-found">Тут пока пусто \\__(ツ)__/</div>')
                    .appendTo('.notifications-content');

        } else {
            $(`.notification:not([data-type=${type}])`).fadeOut(100);
            const items = $(`.notification[data-type=${type}]`).fadeIn(100);
            if (!items[0] && !$('.notifications-content .nothing-found')[0])
                $('<div class="empty nothing-found">Тут пока пусто \\__(ツ)__/</div>')
                    .appendTo('.notifications-content');
            else $('.notifications-content .nothing-found').remove();
        }
    })

    //Filter animes
    .on('click', '.mobile-filter-toggle', function () {
        $('body').toggleClass('filter-open');
        $('.filter-block').removeClass('main');//.find('.collapse').removeClass('collapse');
    })
    //One Anime
    .on('click', '#view-list-button', async function showViewList(e) {
        $(this).find('.arrow-up,.arrow-down').toggleClass('arrow-up').toggleClass('arrow-down');
        const animSpeed = .25;
        const viewList = $(this).next();
        const currentHeight = viewList.height()!;
        const shown = viewList.css('display') != 'none';
        if (shown) {
            viewList
                .stop()
                .css('max-height', currentHeight + 'px')
                .animate({'maxHeight': '-=' + currentHeight}, currentHeight * animSpeed, "linear", () => {
                    viewList.css('display', 'none')
                })
        } else {
            viewList.css('max-height', currentHeight + 'px')//'0px')
                .css('display', 'block')
                .stop()
                .animate({'maxHeight': '10000px'}, animSpeed * 10_000, "linear");
        }
        if (e.originalEvent)
            await DataStore.updateAnimeKey(page_id!, 'show_view_order', !shown);

    })
    .on('click', '.fav-type-fav', async function (e) {
        e.preventDefault();
        if (!user_id) return showNotice('Для совершения данного действия надо авторизоваться!', 'Ошибка доступа', 'error')
        const preview = $(this).parents('.preview-anime'),
            remove = $(this).hasClass('selected'),
            animeId = (preview[0] ? preview.data('anime-id') : page_id!) as number;

        try {
            await (remove ? ServerApi.anime.list.removeFavorite(animeId) : ServerApi.anime.list.setFavorite(animeId));
            const $listEl = $('.view-list .user-status-anime.selected .fa');
            if (remove) {
                const $selectedFavTypeEl = $('.fav-type.selected i');
                $listEl.attr('class', $selectedFavTypeEl[0] ? $selectedFavTypeEl.attr('class')! as string : 'fa');
                $(this).removeClass('selected');
                showNotice(`Аниме удалено из «любимых»`);
            } else {
                $listEl.attr('class', 'fa fa-heart');
                $(this).addClass('selected');
                showNotice(`Аниме добавлено в «любимые»`);
            }
            PreviewAnimeDialog.onFavChanged(+animeId, !remove)
        } catch (e) {
            handleFetchError(e);
        }

    })
    .on('click', ".fav-type", async function () {
        const preview = $(this).parents('.preview-anime'),
            id = $(this).data('id'), remove = $(this).hasClass('selected'),
            animeId = (preview[0] ? preview.data('anime-id') : page_id!) as number;
        try {
            const response = await (
                remove ? ServerApi.anime.list.removeIt(animeId) : ServerApi.anime.list.setIt(animeId, id)
            );
            (preview[0] ? preview : $('html'))
                .find('.fav-type.selected').removeClass('selected');
            const $listEl = $('.view-list .user-status-anime.selected .fa');
            const isFavorite = $('.fav-type-fav').hasClass('selected');
            if (isFavorite) $listEl.attr('class', 'fa fa-heart');
            else $listEl.attr('class', 'fa');
            if (!remove) {
                if (!isFavorite)
                    $listEl.addClass(['fa-eye', 'fa-cloud', 'fa-flag-checkered', 'fa-eye-slash'][id])
                $(this).addClass('selected');
                showNotice(`Аниме добавлено в список «${(favoriteTypes.find(e=>e.id == id))!.title}»`);
            } else {
                //update
                showNotice(`Аниме удалено из списков`);
            }
            PreviewAnimeDialog.onListChanged(+animeId, remove ? null : favoriteTypes.find(e => e.id == id) ?? null);
        } catch (e) {
            handleFetchError(e);
        }
    })
    .on('click', '.other-fav-types', function showDialogBottom(this: HTMLElement, e) {
        const $this = $(this),
            $dialog = $this.children('.bottom-dialog').toggleClass('showed');
        if ($dialog.hasClass('showed')) {
            setTimeout(() => $('html').one('click', function onDialogClick(e) {
                const $target = $(e.target);
                if (!$target.is('.other-fav-types,.other-fav-types *'))
                    showDialogBottom.call($this[0], e);
            }), 0);
            e.preventDefault();
        }
    })
    .on('click', '.poster-increase', async function () {
        if ($(this).hasClass('blocked')) return;
        $(this).addClass('blocked');
        try {
            const $poster = $(this).parents('.poster-block');
            const img = $poster.find<HTMLImageElement>('img')[0];
            const $imgBig = $<HTMLImageElement>('.poster-background .big-poster');
            $imgBig[0]!.loading = 'eager';
            $(this).html(<i className="fa fa-spinner fa-spin"/>);
            try {
                if ($imgBig[0].width <= 0)
                    await new Promise((r, e) => {
                        $imgBig.one('load', r);
                        $imgBig.one('error', e);
                    })
            } finally {
                $(this).html(<i className="far fa-search-plus"/>);
            }

            const deltaSize = $imgBig[0].naturalWidth / $imgBig[0].naturalHeight;
            let width: number, height: number;
            if (deltaSize * window.innerHeight < window.innerWidth) [width, height] = [window.innerHeight * deltaSize, window.innerHeight];
            else [width, height] = [window.innerWidth, window.innerWidth / deltaSize];
            width -= 5;
            height -= 5;
            const $el = $('.poster-background').animate({'--opacity': 0}, 0).animate({
                '--opacity': .9
            }, {
                duration: 500, start() {
                    this.style.setProperty('display', 'block')
                },
                step: function (now) {
                    this.style.setProperty("--opacity", now + "");
                }
            });
            $imgBig
                .css({
                    left: $poster.offset()!.left + 'px',
                    top: $poster.offset()!.top - window.scrollY + 'px',
                    'width': $poster.width()! + 'px',
                    'height': $poster.height()! + 'px',
                    transform: 'translate(0,0)',
                    ...(Object.fromEntries(['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius'].map(k => [k, $(img).css(k)])))
                })
                .animate({
                        left: "50%",
                        top: "50%",
                        z: "-50",
                        width: `${width}px`,
                        height: `${height}px`,
                        "borderTopLeftRadius": 0,
                        "borderTopRightRadius": 0,
                        "borderBottomLeftRadius": 0,
                        "borderBottomRightRadius": 0
                    },
                    {
                        duration: 500, // Animation duration in milliseconds
                        step: function (now, fx) {
                            if (fx.prop === "z") {
                                // Handle scaling during animation
                                $(this).css("transform", "translate(" + now + '%,' + now + "%)");
                            }
                        },
                        complete() {
                            $el.attr('src', (img.dataset as any).full)
                        }
                    })
            $('body').css('overflow-x', 'hidden')
        } catch (e) {
            handleFetchError(e);
        } finally {
            $(this).removeClass('blocked');
        }
    })
    .on('click', '.poster-background', function () {
        const $poster = $('.poster-block');
        const img = $poster.find<HTMLImageElement>('img')[0];
        const width = img.width, height = img.height;
        $(this).animate({'--opacity': 0}, {
            duration: 500, step: function (now) {
                this.style.setProperty("--opacity", now);
            }
        })

            .find('.big-poster')
            .animate({
                left: $poster.offset()!.left + 'px',
                top: $poster.offset()!.top - window.scrollY + 'px',
                z: "0",
                width: `${width}px`,
                height: `${height}px`,
                ...(Object.fromEntries(['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius'].map(k => [k, $(img).css(k)])))
            }, {
                duration: 500, // Animation duration in milliseconds
                step: function (now, fx) {
                    if (fx.prop === "z") {
                        // Handle scaling during animation
                        $(this).css("transform", "translate(" + now + '%,' + now + "%)");
                    }
                },
                complete: function () {
                    $('body').css('overflow-x', '')
                    $(this).parent().css('display', 'none');
                }
            })


    })
    .on('click', '.view-button', function () {
        if ($(this).hasClass('active')) return;
        const view = $(this).data('view');
        setViewList(view);
    })
    //Rate anime
    .on('click', '.rating-list li', async function () {
        if (!user_id)
            return showNotice('Ставить оценку могут только авторизованные пользователи', 'Внимание', 'error');
        if ($(this).hasClass('selected'))
            return showNotice("Невозможно изменить оценку - она осталась той же!", "Ошибка", "error");
        $(".rating-list li.selected").removeClass('selected');
        const $this = $(this).addClass('selected'),
            animeId = ~~$this.parents('.modal-container').data('anime-id'),
            rate: number = (~~$this.data('rate'));
        await rateAnime(animeId, rate);
    })
    .on('click', '#rating-modal .remove-rating', async function () {
        if (!user_id)
            return showNotice('Ставить оценку могут только авторизованные пользователи', 'Внимание', 'error');

        if (!$('.rating-list li.selected')[0])
            return showNotice('Чтобы удалить оценку, её надо сначала поставить -_-', 'Внимание', 'error');
        const animeId = ~~$(this).parents('.modal-container').data('anime-id');
        await rateAnime(animeId, 0);
        $(".rating-list li.selected").removeClass('selected');
    })
    .on('click', '.rating-star', function () {
        if (!$('#current_user_id').val())
            showNotice('Ставить оценку могут только авторизованные пользователи', 'Внимание', 'error');
        else if (![0, 1].includes(+($("#anime_status_id").attr('content') || 0)) || ![0, 1].includes(+($(this).parents('.anime-column').find('.status-block').data('val') || 0)))
            showNotice('На анонсы нельзя ставить оценки!', 'Ошибка', 'error');
        else {
            const id = $(this).parents('.rating-info').data('id');
            const ration = +$(this).parents('.rating-info').find('.user-rating').text()!;
            showModal(id, $('#rating-modal'), isNaN(ration) ? 0 : ration);
        }
    })
    .on('click', '.main-rating', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const votesList = $this.parents('.rating-info').next('.votes-list');
            if (votesList.length > 0) {
                votesList.remove();
                $this.removeClass('blocked');
            } else {
                const anime_id = $this.parents('.rating-info').data('id');
                const data = await ServerApi.anime.rate.getAnimeRates(anime_id);
                const max = Math.max(...data.map(e => e.count));
                const displayOver = $(this).parents('.preview-anime')[0];
                let html = (
                    <div className={`stats-container votes-list${displayOver ? ' other-lists bordered-overflow' : ''}`}>
                        {
                            ...data.map(({count, rating}) => {
                                // const opacity = count / max;
                                // const opacity_val = Math.round((opacity + Number.EPSILON) * 100) / 100 * 0.4 + 0.6;
                                const styles = {
                                    flexBasis: `${(count * 100 / max)}%`,
                                    color: 'var(--main-black)'
                                };
                                const ref: RefObject<HTMLDivElement> = {};
                                const el = (
                                    <div className={`stats-item rating-${rating}`} title={ratingList[rating]}>
                                        <div className="stats-item-column">
                                            <i className="fa fa-star"></i>
                                        </div>
                                        <div className="stats-item-column"
                                             style={{color: 'var(--main-text)'}}>{rating}</div>
                                        <div className="stats-item-column progress-bar-column">
                                            <div className="progress-bar">
                                                <div style={styles} ref={ref} className="background">{count}</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                                // ref.value!.style.background = $(ref.value!).css('background')
                                //     .replace('rgb', 'rgba').replace(')', `, ${opacity_val})`);
                                return el;
                            })

                        }
                    </div>
                )
                $this.parents('.rating-info').after(html);
            }
        } finally {
            $this.removeClass('blocked');
        }

    })
    .on('click', '.delete-post-button', async function () {
        try {
            if (confirm('Вы уверены, что хотите удалить этот пост?')) {
                await ServerApi.posts.delete(page_id!);
                showNotice('Пост успешно удалён.', 'Успех');
                setTimeout(() => window.location.reload(), 1000);
            }
        } catch (e) {
            handleFetchError(e);
        }
    })
    // Recommendations on anime
    .on('click', '#recommended-button', async function () {
        const data = await ServerApi.anime.getRecommendations(page_id!)
        let container = $('.recommend-block');
        if (data.length == 0) {
            container.html(<span className="marker">Еще никто не добавлял похожие аниме.</span>);
        } else {
            const html = <>
                {
                    ...data.map(anime => (
                        <div className="anime-column" data-rec-id={anime.anime_id} data-anime-id={anime.anime_id}>
                            <a className="image-block" href={"/catalog/item/" + anime.anime_url}>
                                <span className="year-block">{anime.year}</span>
                                <span className="status-block"
                                      data-val={anime.anime_status.value}>{anime.anime_status.title}</span>
                                <img src={anime.poster.huge} loading="lazy" alt=""/>
                            </a>
                            <div className="anime-column-info">
                                <a className="anime-title"
                                   href={"/catalog/item/" + anime.anime_url}>{escapeHtml(anime.title)}</a>
                                <div className="recommended-info">
                                </div>
                            </div>
                        </div>
                    ))
                }
                <gap/>
                <gap/>
                <gap/>
            </>;
            container.html(html);

        }
    })
    //Age alert
    .on('click', '.video-button', function () {
        if ([4, 5].includes(+$('#anime_age_rating').attr('content')!)) {
            if (+($('#user_age').attr('content') || 0) >= 18) return;
            const ageConfirmAnimes = JSON.parse(localStorage.ageConfirmAnimes || "{}");
            const thisConfirm = ageConfirmAnimes[page_id!];
            if (!thisConfirm || thisConfirm < Date.now()) {
                $('.main-player').append(
                    <div className="player-alert-container">
                        <div className="player-alert">
                            <h1>18+</h1>
                            <p>Данный контент только для лиц старше 18-ти лет</p>
                            <div className="main-button" id="confirm-age">
                                Мне уже есть 18
                            </div>
                            <span>Укажите дату рождения в профиле, чтобы не видеть этого окна</span>
                        </div>
                    </div>
                );
            }
        }
    })
    .on('click', '#confirm-age', function () {
        const ageConfirmAnimes = JSON.parse(localStorage.ageConfirmAnimes || "{}");
        ageConfirmAnimes[page_id!] = (new Date).addHours(24).getTime();
        localStorage.ageConfirmAnimes = JSON.stringify(ageConfirmAnimes);
        $('.player-alert-container').remove();
    })
    //Light
    .on('click', '.light-button', function () {
        if ($('body').toggleClass('light-off').hasClass('light-off')) {

            let mouseMoveCountdown: any;
            $(document).on('mousemove.light', function () {
                $('.episodes, .player-controls, .video-block-select > *').css('opacity', '1');
                clearTimeout(mouseMoveCountdown);
                mouseMoveCountdown = setTimeout(function () {
                    $('.episodes, .player-controls, .video-block-select > *').css('opacity', '');
                }, 5000);
            }).trigger('mousemove.light');
        } else {
            $('.chat-container').removeClass('light-off');
            $(document).off('mousemove.light');
        }
    })
    .on('click', '.dark-overlay', function () {
        $('.chat-container').removeClass('light-off');
        $('body').removeClass('light-off');
        $(document).off('mousemove.light');
    })
    //Subscribe on blogger button click
    // .on('click', '.subscribe-video-button:not(.blocked)', async function () {
    //     const $this = $(this).addClass('blocked'),
    //         bloggerId = +$(this).data('author')!,
    //         $countEl = $this.parents('.subscribe-block').find('.subscribe-count-number');
    //     try {
    //         if (!user_id) return showNotice('Для подписки необходимо авторизоваться', 'Ошибка', 'error');
    //         if ($this.hasClass('subscribed')) {
    //             await ServerApi.bloggers.unsubscribe(bloggerId);
    //             $this.removeClass('subscribed').text('Подписаться');
    //             $countEl.text(+$countEl.text() - 1 + "")
    //         } else {
    //             await ServerApi.bloggers.subscribe(bloggerId);
    //             $this.addClass('subscribed').text('Отписаться')
    //             $countEl.text(+$countEl.text() + 1 + "")
    //         }
    //     } catch (e) {
    //         handleFetchError(e);
    //     } finally {
    //         $this.removeClass('blocked')
    //     }
    // })
    // Other's list button click
    .on('click', '.other-lists-button', async function () {
        const $this = $(this), animeId = page_id! as number;
        if ($this.hasClass('blocked')) return;
        try {
            $this.addClass('blocked');
            const list = $this.parent().find('.other-lists');
            if (list.length) {
                list.addClass('invisible');
                await new Promise(r => setTimeout(r, 200));
                list.remove();
                $this.removeClass('blocked');
                return;
            }

            const data = await ServerApi.anime.list.getUsersLists(animeId);
            let max = Math.max(...data.map(i => i.count), 1);
            const html = (
                <div className="stats-container other-lists bordered-overflow invisible">
                    {
                        ...data.map(item =>
                            (<OtherListsStatistics max={max}
                                                   title={favoriteTypes.find(e => e.id == item.list_id)!.title!}
                                                   count={item.count}/>)
                        )
                    }
                </div>
            );
            $this.parent().append(html);
            setTimeout(() => {
                $this.parent().find('.invisible').removeClass('invisible');
            }, 200);

            $(document).on("click.otherLists", function (e) {
                const el = $('.other-lists');
                if ($(e.target).closest(el).length) return;
                $(document).off("click.otherLists");
                el.addClass('invisible');
                setTimeout(() => el.remove(), 200);
            });
        } catch (e) {
            handleFetchError(e);
        } finally {
            $this.removeClass('blocked');
        }
    })

    //Edit anime
    .on('input', '.ref-link', function (this: HTMLInputElement) {
        const link: string = $(this).val()! as string; //.data('link').replace('{0}', $(this).val());
        const searchQ: string = $(this).data('search');
        if (link || !searchQ)
            $(this).next().attr('href', link || "about:blank").text('Открыть');
        else $(this).next().attr('href', searchQ.replace('{0}', encodeURIComponent($('input[name=title]').val()! as string))).text('Поиск')
    })

    //Utils
    .on('click', '.drop-icon', function () {
        const $parent: JQuery = $(this).parents('.drop-list-inner');
        if (!$parent.hasClass('block')) {
            $parent.addClass('block');
            if (!$parent.find('.category-list-inner').height()) {
                openDropList($parent);
                $('.drop-list-inner.open').not($parent).each(function () {
                    closeDropList($(this))
                });
            } else {
                closeDropList($parent);
            }
        }
    })
    .on('click', '.tabs-li:not(.no-click)', function () {
        const $this = $(this);
        $this.parent().children('.tabs-li').removeClass('active');
        const block = $this.addClass('active').data('id');

        if ($this.hasClass('li-profile')) {
            $this.parent().attr('data-selected', $this.data('listid'));
        }

        $(block).parent().children('.tab-content').removeClass('active');
        $(block).addClass('active');
        const url: string | undefined = $this.data('url');
        if (url) {
            window.history.replaceState("", "", window.location.pathname + '?tab=' + url);
        }

    })
    .on('click', '.accordion-item', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        try {
            const $el = $this.parent().children('.accordion-content');
            if ($el.css('display') === 'block') {
                //hide

                $el.css('height', $el.outerHeight() + "px");
                await new Promise(r => setTimeout(r, 0));
                $el.css('height', '');
                $el.css('padding', '0');
                await new Promise(r => setTimeout(r, 300));
                $el.css('display', '')

            }
            else {
                //show
                $el.css('transition', '0s all');
                $el.css('display', 'block')

                $el.css('padding', '');

                $el.css('height', 'auto');

                const $needHeight = $el.outerHeight();
                $el.css('padding', '0');
                $el.css('height', '');
                await new Promise(r => setTimeout(r, 0));
                $el.css('transition', '');
                await new Promise(r => setTimeout(r, 0));
                $el.css('padding', '');
                $el.css('height', $needHeight + "px");
                await new Promise(r => setTimeout(r, 300));
                $el.css('height', "auto");
            }
        } finally {
            $this.removeClass('blocked');
        }
    })
    .on('click', '.sub-menu-link > a', e => void e.preventDefault())
    .on('click', '.profile-filter-button', function () {
        $('.profile-filter-body').toggleClass('show');
    })
    .on('click', '.sub-menu-container .sub-menu-container-icon', function () {
        $('.sub-menu-inner-container').toggleClass('show');
    })
    .on('click', '.more-alt-names', function () {
        $(this).remove();
    })
    .on('click', '.shr-button', () => new DialogShare())
    .on('blur', 'input[type=number][min][max]', function () {
        const min = +$(this).attr('min')!, max = +$(this).attr('max')!,
            val = $(this).val()! as number;
        if (!val) return;
        if (val > max) $(this).val(max)[0].dispatchEvent(new Event("change"));
        else if (val < min) $(this).val(min)[0].dispatchEvent(new Event("change"));
    })
    .on('submit', '.login-form', async function (e) {
        e.preventDefault();
        const login = $(this).find('input[name=email]').val()! as string,
            password = $(this).find('input[name=password]').val()! as string;
        if (login.length < 3) return handleFetchError(new YummyServerError("Неправильный логин!"))
        await auth(login, password);
    })
    .on('click', '.main-category', function () {
        const list = $(this).next();
        if (!list.hasClass('block')) {
            list.addClass('block').css('overflow', 'hidden');
            if (!list.height()) {
                $(this).removeClass('bordered').addClass('bordered-top');
                list.css({height: list[0].scrollHeight});
                setTimeout(function () {
                    list.removeClass('block').css({height: 'auto', overflow: 'visible'});
                }, 300);
            } else {
                $(this).removeClass('bordered-top').addClass('bordered');
                list.removeClass('block').css({height: list[0].scrollHeight, overflow: ''});
                setTimeout(function () {
                    list.css({height: ''});
                }, 0);
                list.find('.drop-list-inner.open .drop-icon').not(this).each(function () {
                    // toggleDropList($(this))
                });
            }
        }
    })
    .on('keyup', function (e) {
        //check if active element is not an input
        if ((document.activeElement?.tagName ?? 'BODY') !== 'BODY') return;
        // this would test for whichever key is 40 (down arrow) and the alt key at the same time
        if (e.altKey && ['1', '2', '3', '4'].includes(e.key)) {
            const id = +e.key - 1;
            $(`.fav-type[data-id=${id}]`).trigger('click');
            e.preventDefault();
        }
    })
    .on('click', '#like-edit,#dislike-edit', function likeView() {
        const $this = $(this),
            removeLike = $this.hasClass("selected"),
            action = ($this.prop('id') === 'like-edit' ? 'like' : 'dislike');
        if (!removeLike) {
            $("#dislike-edit,#like-edit").removeClass("selected");
            $this.addClass("selected");
        } else $this.removeClass("selected");
        $.ajax({
            method: removeLike ? 'DELETE' : 'PUT',
            url: (location.pathname + (location.pathname.endsWith("/") ? '' : '/')) + "like?action=" + action + "&date=" + $("input[name=edit_date]").val(),
            success(e) {
                if (e.error) {
                    showNotice(e.error, "Ошибка", "error");
                    if (removeLike) $this.addClass("selected");
                    else $this.removeClass("selected");
                } else {
                    if (removeLike) showNotice("Вы отменили свой голос", "Успех");
                    else showNotice(action === 'like' ? "Вы одобрили изменение к аниме" : 'Вы проголосовали против изменений', "Успех");
                    $("#like-edit").attr('data-count', e.likes);
                    $("#dislike-edit").attr('data-count', e.dislikes);
                }
            },
            error(xhr, textStatus, errorThrown) {
                showNotice(textStatus + " " + errorThrown, "Ошибка", "error");
            }
        })
    })
    .on('click', '.drop-menu-click', function (e) {
        const that = $(this);
        const hidden = that.parent().find('.drop-list');
        if (that.offset()!.left < hidden.width()!)
            hidden.addClass('left');
        else hidden.removeClass('left');
        hidden.parent().toggleClass('invisible');
        $(document).on('click.hidden-menu', function (event) {
            if (!$(event.target).closest('.drop-menu-click, .hidden-menu').length) {
                $('.hidden-menu').addClass('invisible');
                $(document).off('click.hidden-menu');
            }
        });
    })
    .on('click', '.drop-menu-item', function (e) {
        $(this).parents('.hidden-menu').addClass('invisible');
    })
    .on('click', '.video_updated .video-block-description', function () {
        $(this).parent().parent().find('.episodes-container').toggleClass('hidden');
    })
    .on('click', '.video-block-description', function () {
        $(this).parent().find('.episodes-container').toggleClass('hidden');
    })
    .on('click', "#rating-modal", function (e) {
        if (e.target.id === 'rating-modal') closeModal($(this));
    })
    .on('click', '.search-submit .fal', function () {
        $(this).next().trigger('click');
    })
    .on('click', '.show-more', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const $el = $(this).prev();
            if ($el.hasClass('hide')) {
                //show
                const currentHeight = $el.height() + "px";
                $el.css('line-clamp', '10000')
                const potentialHeight = $el.height();
                $el.css('height', currentHeight);

                $this.find('i').css('rotate', '180deg');
                await new Promise<void>(r => $el.animate({'height': potentialHeight + "px"}, 300, r));
                $el.css('height', '')
                    .css('line-clamp', '')
                    .removeClass('hide');
            } else {
                //hide
                $el.addClass('hide');
                const needHeight = $el.height();
                $el.css('line-clamp', '10000')
                    .css('height', $el.height() + 'px');

                $this.find('i').css('rotate', '');
                await new Promise<void>(r => $el.animate({'height': needHeight + "px"}, 300, r));

                $el.css('line-clamp', '')
                    .css('height', '');

            }
        } finally {
            $this.removeClass('blocked')
        }
    })
;


try {
    // Install as application
    let deferredPrompt: Event;

    window.addEventListener('beforeinstallprompt', (e) => {
        console.log(`'beforeinstallprompt' event was fired.`);
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI notify the user they can install the PWA
        // Optionally, send analytics event that PWA install promo was shown.
    });
    if ("serviceWorker" in navigator) {
        // Register a service worker hosted at the root of the
        // site using the default scope.
        navigator.serviceWorker.register("/sw.js", {scope: '/'}).then(
            (registration) => {
                console.log("Service worker registration succeeded:", registration);
            },
            (error) => {
                console.error(`Service worker registration failed: ${error}`);
            }
        );
    }
} catch (e) {
    console.error("Unable to register service worker:", e);
}

async function auth(login: string, password: string, captcha?: string): Promise<any> {
    try {
        await ServerApi.profile.login(login, password, captcha);
        showNotice('Вы успешно авторизовались в аккаунт', 'Успех');
        location.reload();
    } catch (e: any) {
        if (e instanceof YummyServerError) {
            if (e.code === ErrorCode.CaptchaError) {
                let captcha: string;
                try {
                    captcha = await showDialogRecaptcha();
                    return auth(login, password, captcha);
                } catch (e) {
                    handleFetchError("Капча не пройдена");
                    return;
                }
            }
            if (e.code == ErrorCode.InvalidPasswordException) {
                $('input[name=password]').val('')
            }
        }
        handleFetchError(e);
    }

}

async function removeAvatar() {
    if (!await showAskDialog('Удаление аватарки', 'Вы уверены, что хотите удалить аватарку?')) {
        return;
    }
    try {
        await ServerApi.profile.removeAvatar(page_id!);
        showNotice('Аватарка успешно удалена', 'Успех', 'success');
        location.reload();
    } catch (e) {
        handleFetchError(e);
    }
}

export function showWaifuGeneratorWindow() {
    const img: JSX.RefObject<HTMLImageElement> = {}, loadingIcon: JSX.RefObject = {};
    const dialog = (
        <HtmlDialog>
            <div className="top-data">
                <h1>Генератор вайф</h1>
                <div className="content" style="display:block;">
                    <p style={{textAlign: 'center'}}>Тут можно сгенерировать аниме-аватарку на Ваш вкус и цвет</p>
                    <div style={{textAlign: "center"}}>
                        <img id="waifu-img" alt="Картинка" ref={img}/>
                        <i style="display: none" ref={loadingIcon}>
                            <img src={"//img.yani.tv/img/kurukuru.webp"}/>
                        </i>
                        <br/>
                        <button className="main-button generate-waifu bordered transparent" onClick={generateWaifu}><i
                            className="far fa-random"/>Сгенерировать
                        </button>
                    </div>
                    <p>Картинки взяты с <a href="//waifu.pics" target="_blank">waifu.pics</a></p>
                </div>
            </div>
            <div className="bottom-buttons">
                <button className="main-button bordered cancel neutral close-dialog">Отмена</button>
                <button className="main-button bordered save close-dialog" onClick={save}>Сохранить</button>
            </div>
        </HtmlDialog>
    );
    document.body.appendChild(dialog);

    async function generateWaifu() {
        img.value!.style.display = 'none';
        loadingIcon.value!.style.display = '';
        try {
            img.value!.src = '';
            const ava = await ServerApi.profile.randomAva();
            img.value!.src = ava;
            img.value!.style.display = '';
            // $dialog.find('#waifu-img')
            //     .prop('src', ava)
            //     .css('display', 'block');
        } catch (e) {
            handleFetchError(e);
        } finally {
            loadingIcon.value!.style.display = 'none';
        }

    }

    function save() {
        const src = APIGateway + '/profile/waifu/' + img.value!.src.replace('https://', '') + '/';
        // const src = await img.toDataUrl();
        showChangeImageDialog(src);
    }
}

async function rateAnime(animeId: number, rate: number) {
    try {
        let data;
        if (rate == 0) data = await ServerApi.anime.rate.removeRate(animeId);
        else data = await ServerApi.anime.rate.setRate(animeId, rate);
        if (data.response) {
            const ratingBlock = $(`.rating-info[data-id="${animeId}"]`),
                myRatingBlock = ratingBlock.find('.user-rating i').text(' ' + rate);
            if (rate == 0) myRatingBlock.parent().addClass('hidden')
            else {
                const $userRating = myRatingBlock.parent().removeClass('hidden');
                $userRating.attr('class', 'user-rating rating-' + rate);
            }
            ratingBlock.find('.main-rating').text(data.response.rating.toFixed(2));
            ratingBlock.find('.main-rating-info').html(`<span>${data.response.votes}</span> ${formatWord(data.response.votes, 'голос', 'голоса', 'голосов')},`);
            showNotice(rate != 0 ? 'Оценка поставлена' : 'Оценка удалена', '\\_(シ)_/');
        }
    } catch (e) {
        handleFetchError(e);
    } finally {
        closeModal($("#rating-modal"));
    }
}

function updateNotificationCounts() {
    for (let item of Array.from($('.notification-item'))) {
        const $el = $(item),
            type = $el.data('type'),
            jqElement = type === 'all' ? $('.notification') : $(`.notification[data-type="${type}"]`),
            count = jqElement.length;
        $el.data('count', count);
        const badge = $el.find('.badge')
            .text(count + '');
        if (count == 0) badge.addClass('disabled');
        else badge.removeClass('disabled')
    }
}

function showChangeImageDialog(imageBase64Str: string) {
    let cropper: Cropper | undefined;
    const imgElement: JSX.RefObject<HTMLImageElement> = {};
    const panel: JQuery = $(
        <HtmlDialog OnClose={() => {
            if (cropper) cropper.destroy();
            $<HTMLInputElement>('input[name=select-avatar]')[0].value = '';
        }}>
            <div className="top-data">
                <h1>Добавление аватарки</h1>
                <div className="content" style="display:block;">
                    <div style="text-align: center">
                        <img src='' className="cropping-img" style="max-height: calc(100vh - 150px);" alt="Загрузка..."
                             ref={imgElement}/>
                    </div>
                </div>
            </div>
            <div className="bottom-buttons">
                <div className="cancel-button main-button neutral">Отмена</div>
                <div className="save-button main-button " onClick={saveBtnClick}>Сохранить</div>
            </div>
        </HtmlDialog>
    )
        .appendTo('body');
    imgElement.value!.addEventListener('load', function () {
        let width: number = imgElement.value!.width,
            height: number = imgElement.value!.height;
        imgElement.value!.style.width = width + "px";
        imgElement.value!.style.height = height + "px";
        $(imgElement.value!).parent().css({
            width: width,
            height: height,
            left: '50%',
            position: 'inherit',
            transform: 'translateX(-50%)'
        })

        cropper = new Cropper(imgElement.value!, {
            aspectRatio: 1,
            viewMode: 3,
            dragMode: 'move',
            minCropBoxWidth: 200,
            minCropBoxHeight: 200,
            responsive: true,
            modal: false,
            autoCropArea: 1,
            // autoCropArea: 0.65,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            toggleDragModeOnDblclick: false,
            minContainerHeight: height,
            minContainerWidth: width,
            minCanvasHeight: height,
            minCanvasWidth: width,

        });
    });
    imgElement.value!.src = imageBase64Str;

    function saveBtnClick(this: HTMLElement) {
        if ($(this).hasClass('blocked')) return;
        $(this).addClass('blocked');
        cropper?.getCroppedCanvas({
            width: 350,
            minWidth: 350,
            imageSmoothingQuality: 'high',
            height: 350,
            minHeight: 350
        })
            ?.toBlob(async (blob) => {
                try {
                    await ServerApi.profile.setAvatar(page_id!, blob!)
                    showNotice("Аватарка успешно обновлена.\nДля того, чтобы изменения отобразились, обновите страницу.", "Успех", 'success');
                    panel.data('close-event')();
                    window.location.reload();
                } catch (e) {
                    handleFetchError(e);
                } finally {
                    $(this).removeClass('blocked');
                }
            }, 'image/png');

    }
}

function showModal(animeId: number, $element: JQuery, selectedRating: number = 0) {
    const element = (
        <div id="rating-modal" className="modal-container" data-anime-id={animeId}>
            <div className="modal bordered">
                <div className="modal-header">Мой рейтинг<i className="far fa-trash remove-rating"/></div>
                <div className="modal-content-full">
                    <ul className="rating-list">
                        {
                            ...(
                                [
                                    [10, "шедевр", "fa-laugh-beam"],
                                    [9, "великолепно", "fa-laugh"],
                                    [8, "очень хорошо", "fa-grin"],
                                    [7, "хорошо", "fa-smile"],
                                    [6, "неплохо", "fa-meh"],
                                    [5, "посредственно", "fa-meh"],
                                    [4, "никак", "fa-frown"],
                                    [3, "плохо", "fa-frown-open"],
                                    [2, "ужасно", "fa-tired"],
                                    [1, "ничтожно", "fa-dizzy"]
                                ] as [number, string, string][]
                            ).map(
                                item => (
                                    <li className={"materiable" + (selectedRating == item[0] ? ' selected' : '')}
                                        data-rate={item[0]}><i className={["fal", item[2]]}/> {item[0]} - {item[1]}</li>
                                )
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
    console.log("showing modal...")
    document.body.appendChild(element);

    $(element).css("visibility", "visible").animate({'opacity': '+=1'}, 300);
}

function closeModal($modal: JQuery) {
    $('#rating-modal')
        .animate({'opacity': '-=1'}, 300, () => void $modal.remove())
}

$(function onLoad() {
    //#region colors for VK widget
    function hex(x: any): string {
        return ("0" + parseInt(x).toString(16)).slice(-2);
    }

    function rgb2hex(rgb: string) {
        const rgb1: string[] = rgb.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(,\s*\d+\.*\d+)?\)$/)!;
        return "#" + hex(rgb1[1]) + hex(rgb1[2]) + hex(rgb1[3]);
    }


    jQuery.fn.bgColor = function (this: JQuery) {
        return rgb2hex(this.css('background-color') || '');
    };
    jQuery.fn.fgColor = function (this: JQuery) {
        return rgb2hex(this.css('color') || '');
    };

    //#endregion
    updateNotificationCounts();
    if (mobileOperatingSystem === 'iOS') {
        $('#frame').hide();
        $('.top').addClass('ios');
    }
    {
        //Slim select
        const list = $('#dub-select > option').each(function () {
            var dub = $(this);
            var max = 0;
            $('#player-select option[data-name="' + dub.val() + '"]').each(function () {
                const $player = $(this),
                    count = $('.episodes-container[data-id="' + $player.val() + '"] .video-button').length;
                $player.text($player.text() + ' (' + count + ' эп.)')
                    .attr('data-ep', count);
                max = max < count ? count : max;
            });
            dub.text(dub.text() + ' (' + max + ' эп.)').attr('data-ep', max);
        })
        //.sort((a, b)=> -$(a).data('ep')+$(b).data('ep'));
        $('#dub-select').html(list as unknown as string).val('0');
        //init SlimSelect plugin
        $("select.slim-select").slimSelect();
        $('select#video-select').slimSelect();

    }

    $('.update-date,.update-date-mobile').each(function () {
        const date = $(this).data('date');
        if (date) $(this).html(convertTime(date, $(this).hasClass('update-date-mobile')!))
    });
    if (user_id) setTimeout(async function updateStatus() {
        if (document.visibilityState === 'hidden') {
            $(document).one('visibilitychange', updateStatus);
        } else {
            try {
                await ServerApi.profile.updateOnline();
            } catch (e) {
                handleFetchError(e);
            }
            setTimeout(updateStatus, 4.5 * 60_000);
        }
    }, 0);
    if (page_type == 'anime') {
        (DataStore.getAnimeById(page_id!)).then(res => {
            if (res?.show_view_order) $('#view-list-button').trigger('click');
        })
    }
    $<HTMLImageElement>('.poster-block img').one('load', function () {
        if ($(this).hasClass('blured')) return;
        $('.poster-block').append(
            <div className="scope-block update-list" style={{border: 'none'}}>
                <div title="Увеличить" className="poster-increase green-icon-button favourite-button">
                    <i className="far fa-search-plus"></i>
                </div>
            </div>
        );
    })
        .each(function (this: HTMLImageElement) {
            if (this.complete) {
                $(this).trigger('load');
            }
        });
    if ($(window).width()! <= 768) {
        $('.category-list-inner').each(function () {
            var that = $(this);
            if (that.children().length > 1) {
                that.css('display', 'grid').hide();
            } else that.parent().addClass('one')
        })
    }
    //Mute/Unmute element if saved in localStorage
    {
        if (localStorage.muted === 'true')
            $('.notification-volume .fa').removeClass('fa-volume-up').addClass('fa-volume-off');
    }
    {
        $('.menu:not(.tabs) a').each(function () {
            if ((window.location.href == $(this).attr('href')) || ($(this).attr('href') == window.location.protocol + '//' + window.location.host && window.location.pathname == '/')) {
                $(this).parent().addClass('active');
            }
        }).on('click', function () {
            const $this = $(this);
            if ($this.attr('href') !== '#') {
                $this.parent().addClass('active');
            }
        });
    }
    {
        //Show error if it is in request parametera
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('error'))
            showNotice(urlParams.get('error')! as string, urlParams.get('error_title') ?? "Ошибка", 'error');
        else if (urlParams.get("message"))
            showNotice(urlParams.get("message")! as string, urlParams.get("message_title")! ?? ".....");
        let url = new URL(location.href);

        for (const p of ["message", "message_title", "error", "error_title"])
            url.searchParams.delete(p);
        window.history.replaceState('', '', url);
    }

})
try {
    window.history.replaceState({}, document.title, window.location.href.replace(/__cf_chl_jschl_tk__=[^&]+/, ''));
} catch (e) {
    console.error(e); // Старый браузер
}
Websocket.Instance.on<StatisticsUpdateEvent>('statistics', (data) => {
    $("#online-users").text(data.users.online);
    $("#users-count").text(data.users.count);
    $("#animes-count").text(data.animes.count);
    $("#comments-count").text(data.comments.count);
    $("#reviews-count").text(data.reviews.count);
    $("#website-tabs-count").text(data.tabs.count);
    for (let k of Object.keys(data.episodes)) {
        const num = k.replace('h', '');
        //@ts-ignore
        $(`#new-ep-last-hour-${num}`).text(data.episodes[k]!)
    }
})


function setViewList(view: 'list' | 'grid') {
    const sizes = view === 'list' ? '101px' : posterSizes;

    $('.anime-column:not(.user-column) img')
        .attr('sizes', sizes);

    $('body')
        .removeClass('view-page-list view-page-grid')
        .addClass('view-page-' + view);
    $('.view-button')
        .removeClass('active')
        .filter(`[data-view="${view}"]`)
        .addClass('active');
    localStorage.viewPageTop = view;
};
(window as any)['setViewList'] = setViewList;
$(() => !$('body').hasClass('view-page-list') && setViewList(localStorage.viewPageTop ?? 'grid'))